module.exports = __webpack_public_path__ + "img/bg.763bdc9c.jpg";